import React, { lazy, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icon, Text } from "../custom-components";
import { IcHome, IcNotification, IcChevronDown, IcChevronUp, IcChevronRight, IcTime, IcSettings, IcCollapseSidebar } from "../custom-components/Icon";
import { useSelector, useDispatch } from "react-redux";
import { SET_SELECTED_BUSINESS, UPDATE_BUSINESS_ID, CLEAR_SESSION } from "../store/constants/Constants";
import { filterMenuByPermissions } from "../utils/permissions";
import "../styles/sideNav.css"; // Assuming you have a CSS file for styling
import {
  IcBusinessman,
  IcCookies,
  IcDocument,
  IcEngineeringRequest,
  IcGroup,
  IcLayout,
  IcMail,
  IcNetwork,
  IcPageSettings,
  IcRequest,
  IcSms,
  IcStatusSuccessful,
  IcTeam,
  IcTicketDetails,
  IcRequest,
  IcForms,
  IcMail
} from "../custom-components/Icon";
import { IcImage, IcNotes } from "../custom-components/Icon";
import BusinessGroupSelector from "./BusinessGroupSelector";

const SideNav = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const businesses = useSelector((state) => state.common.businesses);
  const selectedBusiness = useSelector((state) => state.common.selectedBusiness);
  const userRole = useSelector((state) => state.common.userRole);
  const permissions = useSelector((state) => state.common.permissions);
  const userOriginalBusinessId = useSelector((state) => state.common.user_original_business_id);
  const tenantId = useSelector((state) => state.common.tenant_id);

  const path = location.pathname;
  
  const navRef = useRef(null);
  const profileMenuRef = useRef(null);

  const [isSecondaryPanelOpen, setIsSecondaryPanelOpen] = useState(true);
  const [activeRailId, setActiveRailId] = useState("Dashboard");
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const handleLogOut = () => {
    dispatch({ type: CLEAR_SESSION });
    sessionStorage.clear();
    localStorage.clear();
    // Assuming disableSandboxMode is handled or omitted for simple logout in SideNav
    navigate('/adminLogin');
  };

  const handleProfile = () => {
    setShowProfileMenu(false);
    navigate('/profile');
  };

  // Filter business groups based on user type
  // If user_original_business_id === tenant_id, user is super admin and sees all businesses
  // Otherwise, user only sees their own business
  const filteredBusinesses = React.useMemo(() => {
    console.log("SideNav - userOriginalBusinessId:", userOriginalBusinessId);
    console.log("SideNav - tenantId:", tenantId);
    console.log("SideNav - all businesses:", businesses);

    if (!businesses || businesses.length === 0) return [];

    const isSuperAdmin = userOriginalBusinessId === tenantId;
    console.log("SideNav - isSuperAdmin:", isSuperAdmin);

    if (isSuperAdmin) {
      console.log("SideNav - Super Admin: showing all businesses");
      return businesses;
    } else {
      console.log("SideNav - Regular user: filtering to own business");
      const filtered = businesses.filter(b => b.businessId === userOriginalBusinessId);
      console.log("SideNav - filtered businesses:", filtered);
      return filtered;
    }
  }, [businesses, userOriginalBusinessId, tenantId]);

  const handleBusinessChange = (e) => {
    const selectedId = e.target.value;

    console.log("selectedId: ", selectedId);

    dispatch({
      type: SET_SELECTED_BUSINESS,
      payload: selectedId,
    });

    dispatch({ type: UPDATE_BUSINESS_ID, payload: selectedId });

  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: <IcHome height={20} width={20} />,
      path: "/dpo-dashboard",
    },

    { type: "heading", label: "Privacy Management", icon: <IcStatusSuccessful height={20} width={20} /> },
    { type: "group_title", label: "Consent", icon: <IcStatusSuccessful height={16} width={16} /> },
    { label: "Consent Templates", path: "/templates", icon: <IcDocument height={14} width={14} /> },
    { label: "Consent Configuration", path: "/consent", icon: <IcSettings height={14} width={14} /> },
    
    { type: "group_title", label: "Cookies", icon: <IcCookies height={16} width={16} /> },
    { label: "Cookie Templates", path: "/registercookies", icon: <IcDocument height={14} width={14} /> },
    { label: "Cookie Categories", path: "/cookie-category", icon: <IcGroup height={14} width={14} /> },

    { type: "group_title", label: "Rights Management (DSAR)", icon: <IcDocument height={16} width={16} /> },
    { label: "User Portal Branding", path: "/user-dashboard", icon: <IcImage height={14} width={14} /> },
    { label: "Grievance Templates", path: "/grievanceFormTemplates", icon: <IcForms height={14} width={14} /> },
    { label: "Grievance Configuration", path: "/grievance", icon: <IcSettings height={14} width={14} /> },
    { label: "Email, SMS templates", path: "/notification-templates", icon: <IcMail height={14} width={14} /> },
    { label: "Notification Configuration", path: "/notification", icon: <IcSettings height={14} width={14} /> },

    { type: "heading", label: "Governance", icon: <IcLayout height={20} width={20} /> },
    { type: "group_title", label: "Governance", icon: <IcDocument height={16} width={16} /> },
    { label: "DPO Dashboard", path: "/dpo-dashboard?view=governance", icon: <IcHome height={14} width={14} /> },
    { label: "Record of Processing Activities (ROPA)", path: "/ropa", icon: <IcNotes height={14} width={14} /> },
    { label: "Cookie Register", path: "/cookieslogs", icon: <IcCookies height={14} width={14} /> },
    { label: "Consent Register", path: "/consent-datasets", icon: <IcDocument height={14} width={14} /> },
    { label: "Consent Logs", path: "/consentLogs", icon: <IcTicketDetails height={14} width={14} /> },
    { label: "Data Lineage (upcoming)", path: "/data-lineage", icon: <IcNetwork height={14} width={14} /> },
    { type: "group_title", label: "Grievances", icon: <IcRequest height={16} width={16} /> },
    { label: "Grievance Register", path: "/request", icon: <IcRequest height={14} width={14} /> },
    { type: "group_title", label: "Breach Management", icon: <IcTicketDetails height={16} width={16} /> },
    { label: "Breach Notification", path: "/breach-notifications", icon: <IcNotification height={14} width={14} /> },
    { label: "DPB Digital Office Notification (upcoming)", path: "/dpb-digital-office-sync", icon: <IcNotification height={14} width={14} /> },

    { type: "heading", label: "Reports", icon: <IcNotes height={20} width={20} /> },
    { label: "Audit and Compliance Reports", path: "/audit-compliance", icon: <IcDocument height={14} width={14} /> },
    { label: "Consent Callbacks and Data Deletion Report", path: "/data-compliance-report", icon: <IcNetwork height={14} width={14} /> },
    { label: "Data deletion and purge dashboard", path: "/data-deletion-purge-dashboard", icon: <IcLayout height={14} width={14} /> },
    { label: "Scheduler Statistics", path: "/scheduler-stats", icon: <IcTime height={14} width={14} /> },

    { type: "heading", label: "Settings", icon: <IcSettings height={20} width={20} /> },
    { type: "group_title", label: "Platform Configuration", icon: <IcSettings height={16} width={16} /> },
    { label: "Master Data (PII data types, items)", path: "/master?tab=PII", icon: <IcPageSettings height={14} width={14} /> },
    { label: "Data Processors", path: "/master?tab=DataProcessor", icon: <IcGroup height={14} width={14} /> },
    { label: "Processing Activities", path: "/master?tab=ProcessingActivity", icon: <IcNotes height={14} width={14} /> },
    { label: "Processing Purposes", path: "/master?tab=Purpose", icon: <IcDocument height={14} width={14} /> },
    { label: "Data Retention", path: "/retention-policies", icon: <IcTime height={14} width={14} /> },

    { type: "group_title", label: "Organization Setup", icon: <IcTeam height={16} width={16} /> },
    { label: "Business Units", path: "/business", icon: <IcBusinessman height={14} width={14} /> },
    { label: "Business Hierarchy", path: "/organization-map", icon: <IcNetwork height={14} width={14} /> },
    { label: "Users & Teams", path: "/users", icon: <IcTeam height={14} width={14} /> },
    { label: "Roles & Permissions", path: "/roles", icon: <IcGroup height={14} width={14} /> },
    { label: "Data Protection Officer (DPO)", path: "/dataProtectionOfficer", icon: <IcBusinessman height={14} width={14} /> },
  ];

  // Filter menu items based on user permissions
  const filteredMenuItems = filterMenuByPermissions(menuItems, userRole, permissions);

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const checkIsActive = React.useCallback((menuPath) => {
    if (!menuPath) return false;
    if (menuPath.includes('?')) {
      const [p, query] = menuPath.split('?');
      return location.pathname === p && location.search.includes(query);
    }
    return location.pathname === menuPath && !location.search.includes('view=governance');
  }, [location.pathname, location.search]);

  useEffect(() => {
    let foundRail = "Dashboard";
    let currentRailLabel = "Dashboard";
    
    for (const item of filteredMenuItems) {
      if (item.type === "heading") {
        currentRailLabel = item.label;
      } else if (item.path && checkIsActive(item.path)) {
        foundRail = currentRailLabel;
        break;
      }
    }
    setActiveRailId(foundRail);
  }, [location.pathname, location.search, checkIsActive, filteredMenuItems]);

  // Compute hierarchy for Rail View
  const railItems = [];
  let currentRail = null;
  let currentGroup = null;

  filteredMenuItems.forEach((item) => {
    if (item.label === "Dashboard") {
      railItems.push({ ...item, id: item.label, groups: [] });
    } else if (item.type === "heading") {
      currentRail = { ...item, id: item.label, groups: [] };
      railItems.push(currentRail);
      currentGroup = null;
    } else if (item.type === "group_title") {
      currentGroup = { ...item, items: [] };
      if (currentRail) {
        currentRail.groups.push(currentGroup);
      }
    } else if (item.type !== "separator") {
      if (currentGroup) {
        currentGroup.items.push(item);
      } else if (currentRail) {
        if (currentRail.groups.length === 0) {
          currentRail.groups.push({ id: 'default', label: '', items: [] });
        }
        currentRail.groups[0].items.push(item);
      }
    }
  });

  const activeRailItemObj = railItems.find(r => r.id === activeRailId) || railItems[0];
  const hasSecondaryPanel = activeRailItemObj && activeRailItemObj.groups && activeRailItemObj.groups.length > 0 && activeRailItemObj.id !== "Dashboard";
  const showSecondaryPanel = hasSecondaryPanel && isSecondaryPanelOpen;

  // Update global CSS variable for app-layout margin
  useEffect(() => {
    let newWidth = '80px';
    if (showSecondaryPanel) {
      newWidth = '340px';
    }
    document.documentElement.style.setProperty('--sidebar-width', newWidth);
  }, [showSecondaryPanel]);

  // Hide SideNav on home/login/signup + cookie report pages
  if (
    path === "/" ||
    path === "/adminLogin" ||
    path === "/signup" ||
    path === "/contact" ||
    path.startsWith("/registercookies/report")
  ) {
    return null;
  }

  return (
    <div ref={navRef} className={`sideBar-outer-container ${isOpen ? 'show' : ''} collapsed`} data-tour="sidebar-menu">
          <div style={{ display: 'flex', width: '100%', height: '100%' }}>
            {/* Icon Rail */}
            <div className="icon-rail">
              <div style={{ flex: 1, overflowY: 'auto', width: '100%', marginTop: '16px' }} className="rail-scroll">
                {railItems.map((rItem, idx) => {
                  // A rail item is active if it's the currently selected rail tab OR if one of its children is active
                  // A rail item is active if it's the currently selected rail tab
                  const isRailActive = activeRailId === rItem.id;
                  
                  return (
                    <div 
                      key={idx}
                      className={`rail-item ${isRailActive ? 'active' : ''}`}
                      onClick={() => {
                        const alreadyOnThisRail = activeRailId === rItem.id;
                        setActiveRailId(rItem.id);
                        setIsSecondaryPanelOpen(true);
                        // Reopening the current section should stay on the page already open.
                        if (alreadyOnThisRail) return;
                        if (!rItem.groups || rItem.groups.length === 0 || rItem.id === "Dashboard") {
                          if (rItem.path) handleNavigation(rItem.path);
                        } else {
                          let firstPath = null;
                          if (rItem.groups) {
                            for (const g of rItem.groups) {
                              if (g.items && g.items.length > 0) {
                                firstPath = g.items[0].path;
                                break;
                              }
                            }
                          }
                          if (firstPath) {
                            handleNavigation(firstPath);
                          } else if (rItem.path) {
                            handleNavigation(rItem.path);
                          }
                        }
                      }}
                    >
                      {rItem.icon ? (
                        <Icon kind={isRailActive ? "background-bold" : "default"} ic={rItem.icon} color={isRailActive ? "primary_60" : "primary_grey_80"} size="small" />
                      ) : (
                        <Icon kind={isRailActive ? "background-bold" : "default"} ic={<IcSettings />} color={isRailActive ? "primary_60" : "primary_grey_80"} size="small" />
                      )}
                      <Text style={{ fontSize: '10px', color: isRailActive ? '#2dd4bf' : '#9ca3af', marginTop: '6px', textAlign: 'center', fontWeight: isRailActive ? '600' : '500' }}>
                        {rItem.label === "Privacy Management" ? "Privacy" : rItem.label}
                      </Text>
                    </div>
                  );
                })}
              </div>
              
              {/* Profile Avatar at Bottom */}
              <div ref={profileMenuRef} style={{ marginTop: 'auto', marginBottom: '16px', position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div 
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowProfileMenu(!showProfileMenu);
                  }}
                  style={{
                    width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#0d9488', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                    color: '#fff', fontWeight: 'bold', fontSize: '14px',
                    boxShadow: showProfileMenu ? '0 0 0 2px #fff, 0 0 0 4px #0d9488' : 'none'
                  }}
                >
                  F
                </div>

                {/* Profile Popover */}
                {showProfileMenu && (
                  <div 
                    style={{
                      position: 'absolute', left: '60px', bottom: '0', width: '220px', 
                      backgroundColor: '#ffffff', borderRadius: '4px', border: '1px solid #e5e7eb', 
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      zIndex: 1000, padding: '4px 0'
                    }}
                  >
                    <div 
                      className="sideBar-menu-click" 
                      onClick={handleProfile}
                      style={{ padding: '12px 16px', cursor: 'pointer', backgroundColor: 'transparent' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <Text appearance="body-s" style={{ color: '#1f2937', fontWeight: '500' }}>Profile</Text>
                    </div>
                    <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '4px 0' }}></div>
                    <div 
                      className="sideBar-menu-click" 
                      onClick={handleLogOut} 
                      style={{ padding: '12px 16px', cursor: 'pointer', backgroundColor: 'transparent' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <Text appearance="body-s" style={{ color: '#1f2937', fontWeight: '500' }}>Log Out</Text>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Secondary Panel */}
            {showSecondaryPanel && (
              <div className="secondary-panel">
                <div style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <Text appearance="heading-xs" style={{ color: '#ffffff', fontWeight: '600', fontSize: '16px' }}>
                    {activeRailItemObj.label}
                  </Text>
                  <div 
                    onClick={() => setIsSecondaryPanelOpen(false)}
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px', borderRadius: '4px', border: '1px solid #374151', backgroundColor: 'transparent' }}
                  >
                    <IcCollapseSidebar color="primary_grey_80" size="small" />
                  </div>
                </div>
                <div style={{ padding: '0 12px', flex: 1, overflowY: 'auto' }} className="rail-scroll">
                  {activeRailItemObj.groups.map((group, gIdx) => (
                    <div key={gIdx} style={{ marginBottom: '16px' }}>
                      {group.label && (
                        <div style={{ padding: '0 16px', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                          {group.icon ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Icon ic={group.icon} size="small" color="primary_grey_60" />
                            </div>
                          ) : null}
                          <Text appearance="body-xs" style={{ color: '#9ca3af', marginLeft: group.icon ? '8px' : '0', fontSize: '11px', fontWeight: '600' }}>
                            {group.label}
                          </Text>
                        </div>
                      )}
                      {group.items && group.items.map(child => {
                        const isActive = checkIsActive(child.path);
                        const childLabel = child.label;
                        
                        return (
                          <div
                            key={child.path}
                            className={`sideBar-menu-click ${isActive ? "active" : "inactive"}`}
                            onClick={() => handleNavigation(child.path)}
                            style={{ 
                              padding: group.label ? '8px 16px 8px 44px' : '8px 16px',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            {!group.label && child.icon && (
                              <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                <Icon ic={child.icon} size="small" color={isActive ? "primary_60" : "primary_grey_60"} />
                              </div>
                            )}
                            <Text appearance="body-s" style={{ color: isActive ? '#ffffff' : '#d1d5db', fontWeight: isActive ? '600' : '500' }}>
                              {childLabel}
                            </Text>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
      </div>
    );
};

export default SideNav;
